import TicketDetailSolution from './TicketDetailSolution';

export default TicketDetailSolution;
